export const DEFAULT_BASE = "/PDF/ContabilidadGubernamental";

export const CATEGORIA_LABELS = {
  InformacionContable: "Información Contable",
  InformacionPresupuestaria: "Información Presupuestaría",
  InformacionProgramatica: "Información Prográmatica",
  BienesMuebles: "Bienes Muebles E Inmuebles",
  Transparencia: "Transparencia",
  LDF: "Ley De Disciplina Financiera",
  OtrasObligaciones: "Otras Obligaciones",
};

export const contabilidadData = {
  2026: {
    base: "/PDF/ContabilidadGubernamental",
    label: "Ejercicio 2026",
    trimestres: {
      "1T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Iniciativa de la Ley de Ingresos", file: "A_Iniciativa_Ley_Ingresos.pdf" },
            { label: "Proyecto del Presupuesto de Egresos", file: "B_Proyecto_Presupuesto_Egresos.pdf" },
            { label: "Ley de Ingresos y del Presupuesto de Egresos", file: "C_Ley_Ingresos_Presupuesto.pdf" },
            { label: "Calendario de Ingresos", file: "D_Calendario_Ingresos.pdf" },
            { label: "Calendario de Presupuesto de Egresos", file: "E_Calendario_Egresos.pdf" },
            { label: "Tabulador De Sueldos", file: "F_Tabulador_Sueldos.pdf" },
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },
      "2T": {
        label: "Segundo Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },
      "3T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },
    },
  },

  2025: {
    label: "Ejercicio 2025",
    trimestres: {
      "1T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Iniciativa de la Ley de Ingresos", file: "A_Iniciativa_Ley_Ingresos.pdf" },
            { label: "Proyecto del Presupuesto de Egresos", file: "B_Proyecto_Presupuesto_Egresos.pdf" },
            { label: "Ley de Ingresos y del Presupuesto de Egresos", file: "C_Ley_Ingresos_Presupuesto.pdf" },
            { label: "Calendario de Ingresos", file: "D_Calendario_Ingresos.pdf" },
            { label: "Calendario de Presupuesto de Egresos", file: "E_Calendario_Egresos.pdf" },
            { label: "Tabulador De Sueldos", file: "F_Tabulador_Sueldos.pdf" },
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales Ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "2T": {
        label: "Segundo Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "3T": {
        label: "Tercer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
            { label: "Indicadores de Postura Fiscal", file: null },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "4T": {
        label: "Cuarto Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
            { label: "Informe sobre Estudios Actuariales", file: "M_Informe_Estudios_Actuariales.pdf" },
            { label: "Guía de Cumplimiento de la Ley de Disciplina Financiera", url: "/PDF/ContabilidadGubernamental/2025/4T/LDF/N_Guia_Cumplimiento_LDF.pdf" },
          ],
        },
      },
    },
  },

  2024: {
    label: "Ejercicio 2024",
    trimestres: {
      "1T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Iniciativa de la Ley de Ingresos", file: "A_Iniciativa_Ley_Ingresos.pdf" },
            { label: "Proyecto del Presupuesto de Egresos", file: "B_Proyecto_Presupuesto_Egresos.pdf" },
            { label: "Ley de Ingresos y del Presupuesto de Egresos", file: "C_Ley_Ingresos_Presupuesto.pdf" },
            { label: "Calendario de Ingresos", file: "D_Calendario_Ingresos.pdf" },
            { label: "Calendario de Presupuesto de Egresos", file: "E_Calendario_Egresos.pdf" },
            { label: "Tabulador De Sueldos", file: "F_Tabulador_Sueldos.pdf" },
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "G_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "H_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "2T": {
        label: "Segundo Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "3T": {
        label: "Tercer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "4T": {
        label: "Cuarto Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
            { label: "Informe sobre Estudios Actuariales", file: "M_Informe_Estudios_Actuariales.pdf" },
          ],
        },
      },
    },
  },



2023: {
  label: "Ejercicio 2023",
  trimestres: {
      "1T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Iniciativa de la Ley de Ingresos", file: "A_Iniciativa_Ley_Ingresos.pdf" },
            { label: "Proyecto del Presupuesto de Egresos", file: "B_Proyecto_Presupuesto_Egresos.pdf" },
            { label: "Ley de Ingresos y del Presupuesto de Egresos", file: "C_Ley_Ingresos_Presupuesto.pdf" },
            { label: "Calendario de Ingresos", file: "D_Calendario_Ingresos.pdf" },
            { label: "Calendario de Presupuesto de Egresos", file: "E_Calendario_Egresos.pdf" },
            { label: "Tabulador De Sueldos", file: "F_Tabulador_Sueldos.pdf" },
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "G_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "H_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "2T": {
        label: "Segundo Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "3T": {
        label: "Tercer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "4T": {
        label: "Cuarto Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [

            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
            { label: "Informe sobre Estudios Actuariales", file: "M_Informe_Estudios_Actuariales.pdf" },
          ],
        },
      },
    },
},
2022: {
    label: "Ejercicio 2022",
    trimestres: {
      "1T": {
        label: "Primer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
            { label: "Indicadores de Postura Fiscal", file: "D_Indicadores_Postura_Fiscal.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Iniciativa de la Ley de Ingresos", file: "A_Iniciativa_Ley_Ingresos.pdf" },
            { label: "Proyecto del Presupuesto de Egresos", file: "B_Proyecto_Presupuesto_Egresos.pdf" },
            { label: "Ley de Ingresos y del Presupuesto de Egresos", file: "C_Ley_Ingresos_Presupuesto.pdf" },
            { label: "Calendario de Ingresos", file: "D_Calendario_Ingresos.pdf" },
            { label: "Calendario de Presupuesto de Egresos", file: "E_Calendario_Egresos.pdf" },
            { label: "Tabulador De Sueldos", file: "F_Tabulador_Sueldos.pdf" },
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "G_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "H_Informe_Cuentas_Pagar.pdf" },
          ],
          OtrasObligaciones: [
            { label: "Metodología", file: "5.1_Metodologia.pdf" },
            { label: "Programa Anual de Evaluaciones", file: "5.2_Programa_Anual_Evaluaciones.pdf" },
            { label: "Matriz de Indicadores para Resultados", file: "5.3_Matriz_de_Indicadores.pdf" },
          ],
        },
      },

      "2T": {
        label: "Segundo Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
          ],
        },
      },

      "3T": {
        label: "Tercer Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
        },
      },

      "4T": {
        label: "Cuarto Trimestre",
        categorias: {
          InformacionContable: [
            { label: "Estado De Actividades", file: "A_Estado_Actividades.pdf" },
            { label: "Estado De Situación Financiera", file: "B_Estado_Situacion_Financiera.pdf" },
            { label: "Estado De Variación En La Hacienda Pública", file: "C_Estado_Variacion_Hacienda.pdf" },
            { label: "Estado De Cambios En La Situación Financiera", file: "D_Estado_Cambios_Situacion.pdf" },
            { label: "Estado de Flujo de Efectivo", file: "E_Estados_Flujos_Efectivo.pdf" },
            { label: "Informes Sobre Pasivos Contingentes", file: "F_Informes_Pasivos_Contingentes.pdf" },
            { label: "Notas A Los Estados Financieros", file: "G_Notas_Estados_Financieros.pdf" },
            { label: "Estado Analítico Del Activo", file: "H_Estado_Analitico_Activo.pdf" },
            { label: "Estado Analítico De La Deuda Y Otros Pasivos", file: "I_Estado_Analitico_Deuda.pdf" },
          ],
          InformacionPresupuestaria: [
            { label: "Estado Analitico De Ingresos", file: "A_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPE Clasificación Administrativa", file: "B1_EAEPE_Administrativa.pdf" },
            { label: "EAEPE Clasificación Economica", file: "B2_EAEPE_Economica.pdf" },
            { label: "EAEPE Clasificación por Objeto del Gasto", file: "B4_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPE Clasificación Funcional", file: "B3_EAEPE_Funcional.pdf" },
            { label: "Endeudamiento Neto", file: "C_Endeudamiento_Neto.pdf" },
            { label: "Intereses de la Deuda", file: "D_Intereses_Deuda.pdf" },
            { label: "Flujo de Fondos", file: "E_Flujo_Fondos.pdf" },
          ],
          InformacionProgramatica: [
            { label: "Gasto por Categoria Programatica", file: "A_Gasto_Programatica.pdf" },
            { label: "Programas y Proyectos de Inversión", file: "B_Programas_Proyectos_Inversion.pdf" },
            { label: "Indicadores de Resultados", file: "C_Indicadores_Resultados.pdf" },
          ],
          BienesMuebles: [
            { label: "A) Relación de Bienes Muebles", file: "A_Relacion_Bienes_Muebles.pdf" },
            { label: "B) Relación de Bienes Inmuebles", file: "B_Relacion_Bienes_Inmuebles.pdf" },
          ],
          Transparencia: [
            { label: "Montos Pagados por Ayudas y Subsdios", file: "G_Montos_Pagados_Ayudas.pdf" },
            { label: "Ejercicio y destino de Gasto Federalizado y Reintegros", file: "H_Ejercicio_Destino_Gasto.pdf" },
            { label: "Obligaciones Pagadas o Garantizadas con Fondos Federales", file: "I_Obligaciones_Fondos_Federales.pdf" },
            { label: "Programas con Recursos Federales por Orden de Gobierno", file: "J_Programas_Recursos_Concurrente.pdf" },
            { label: "Cuentas Bancarias Productivas Especificas", file: "K_Relacion_Cuentas_Bancarias.pdf" },
            { label: "Evaluación de los Recursos Federales ministrados a las Entidades Federativas", file: "L_Evaluacion_Recursos_Federales.pdf" },
            { label: "Manual de Contabilidad Gubernamental", file: "M_Manual_Contabilidad_Gubernamental.pdf" },
          ],
          LDF: [
            { label: "Estado de Situación Financiera Detallado", file: "A_Estado_Situacion_Financiera.pdf" },
            { label: "Informe Analítico de la Deuda Pública y Otros Pasivos", file: "B_Informe_Analitico_Deuda.pdf" },
            { label: "Informe Analítico de Obligaciones Diferentes de Financiamientos", file: "C_Informe_Analitico_Obligaciones.pdf" },
            { label: "Balance Presupuestario", file: "D_Balance_Presupuestario.pdf" },
            { label: "Estado Analítico de Ingresos Detallado", file: "E_Estado_Analitico_Ingresos.pdf" },
            { label: "EAEPED Clasificación por Objeto del Gasto", file: "F_EAEPE_Objeto_Gasto.pdf" },
            { label: "EAEPED Clasificación Administrativa", file: "F_EAEPE_Administrativa.pdf" },
            { label: "EAEPED Clasificación Funcional", file: "F_EAEPE_Funcional.pdf" },
            { label: "EAEPED Clasificación De Servicios Personales Por Categoria", file: "F_EAEPE_Servicios_Personales.pdf" },
            { label: "Proyecciones de Ingresos", file: "G_Proyecciones_Ingresos.pdf" },
            { label: "Proyecciones de Egresos", file: "H_Proyecciones_Egresos.pdf" },
            { label: "Resultados de Ingresos", file: "I_Resultados_Ingresos.pdf" },
            { label: "Resultados de Egresos", file: "J_Resultados_Egresos.pdf" },
            { label: "Modificaciones del Gasto - LDF", file: "K_Modificaciones_Gasto.pdf" },
            { label: "Información de Cuentas Por Pagar - LDF", file: "L_Informe_Cuentas_Pagar.pdf" },
            { label: "Informe sobre Estudios Actuariales", file: "M_Informe_Estudios_Actuariales.pdf" },
          ],
        },
      },
    },
  },
};

export function getDocHref(year, trimestre, categoriaKey, doc) {
  if (doc.url) return doc.url;
  if (!doc.file) return null;
  var ejercicio = contabilidadData[year];
  var base = (ejercicio && ejercicio.base) || DEFAULT_BASE;
  return base + "/" + year + "/" + trimestre + "/" + categoriaKey + "/" + doc.file;
}